export default __webpack_public_path__ + "static/media/newlogo.a7dea515.png";